import { faExpandAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ToolTip } from 'src/common/components/tool-tip';
import { StyleActionButton } from '../split-screen-navigation/split-screen-navigation.styles';
export interface AccessVmCountDownProps {
  currentTabIndex: number;
}
export const AccessVmCountDown = ({
  currentTabIndex
}: AccessVmCountDownProps) => <div data-sentry-component="AccessVmCountDown" data-sentry-source-file="access-vm-count-down.tsx">
    <ToolTip toolTipText="View in full screen" data-sentry-element="ToolTip" data-sentry-source-file="access-vm-count-down.tsx">
      <StyleActionButton aria-label="full-screen" type="button" onClick={() => window.open(`/fullscreen-vms/${currentTabIndex}`)} data-sentry-element="StyleActionButton" data-sentry-source-file="access-vm-count-down.tsx">
        <FontAwesomeIcon icon={faExpandAlt} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="access-vm-count-down.tsx" />
      </StyleActionButton>
    </ToolTip>
  </div>;